import { Phone, MessageCircle, PhoneCall } from 'lucide-react';
import { useState } from 'react';
import { trackWhatsAppClick, trackPhoneClick } from '../utils/conversionTracking';
import CallbackForm from './CallbackForm';

const MobileStickyButtons = () => {
  const phoneNumber = '+919205891804';
  const [showCallback, setShowCallback] = useState(false);
  const [waLoading, setWaLoading] = useState(false);

  const handlePhoneClick = () => {
    trackPhoneClick(phoneNumber);
  };

  const handleWhatsAppClick = async (e) => {
    e.preventDefault();
    setWaLoading(true);
    const waUrl = await trackWhatsAppClick();
    window.open(waUrl, '_blank');
    setWaLoading(false);
  };

  return (
    <>
      {/* Callback Form Modal */}
      {showCallback && (
        <div className="lg:hidden fixed inset-0 z-50 bg-black/50 flex items-end">
          <div className="bg-white w-full rounded-t-2xl p-6 shadow-2xl animate-slide-up">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Request a Call Back</h3>
              <button 
                onClick={() => setShowCallback(false)}
                className="text-gray-500 hover:text-black text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <CallbackForm compact={true} />
          </div>
        </div>
      )}

      {/* Sticky Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 backdrop-blur-xl bg-white/98 border-t border-gray-200/50 shadow-2xl">
        <div className="flex gap-2 p-3 max-w-2xl mx-auto">
          {/* Call Button */}
          <a
            href={`tel:${phoneNumber}`}
            onClick={handlePhoneClick}
            className="group flex-1 bg-black text-white py-3 px-4 rounded-full font-bold text-xs flex items-center justify-center gap-2 shadow-lg hover:shadow-xl active:scale-95 transition-all"
            data-testid="mobile-sticky-call"
          >
            <Phone className="w-4 h-4" />
            <span className="uppercase tracking-wider">Call</span>
          </a>

          {/* WhatsApp Button */}
          <button
            onClick={handleWhatsAppClick}
            disabled={waLoading}
            className="group flex-1 bg-white text-black py-3 px-4 rounded-full font-bold text-xs flex items-center justify-center gap-2 shadow-lg hover:shadow-xl active:scale-95 transition-all border-2 border-black disabled:opacity-50"
            data-testid="mobile-sticky-whatsapp"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="uppercase tracking-wider">{waLoading ? 'Opening...' : 'WhatsApp'}</span>
          </button>

          {/* Callback Button */}
          <button
            onClick={() => setShowCallback(true)}
            className="group flex-1 bg-gray-100 text-black py-3 px-4 rounded-full font-bold text-xs flex items-center justify-center gap-2 shadow-lg hover:shadow-xl active:scale-95 transition-all border border-gray-300"
            data-testid="mobile-sticky-callback"
          >
            <PhoneCall className="w-4 h-4" />
            <span className="uppercase tracking-wider">Call Back</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileStickyButtons;
